/**
 * Decide si un aviso nuevo entra a la cola visible.
 *
 * Una pantalla que carga varios bloques a la vez falla varias veces por la misma causa (sin red:
 * el balance, la deuda, la cuota y la notificación, cada uno con su aviso), y apilaba cinco
 * recuadros idénticos que tapaban la pantalla. Se muestra uno solo.
 *
 * Solo afecta lo que ve el usuario: a Sentry se sigue reportando cada fallo por separado, porque
 * la repetición sí es información para quien depura.
 *
 * Vive fuera del componente para poder probarla sin montar React.
 */
export function agregarSinRepetir<T extends { type: string; message: string }>(
  cola: T[],
  nuevo: T
): T[] {
  const yaEstaVisible = cola.some((t) => t.type === nuevo.type && t.message === nuevo.message);
  return yaEstaVisible ? cola : [...cola, nuevo];
}
